export interface ComicChapter {
  id: string;
  title: string;
  number: number;
  updatedAt: string;
}

export interface Comic {
  id: string;
  title: string;
  author: string;
  cover: string;
  category: string;
  tags: string[];
  description: string;
  rating: number;
  status: 'serializing' | 'completed';
  chapters: ComicChapter[];
  views: number;
  updatedAt: string;
  createdAt: string;
}

export const categories = [
  { slug: 'all', name: '全部', icon: 'ri-grid-line' },
  { slug: 'romance', name: '恋爱', icon: 'ri-heart-line' },
  { slug: 'fantasy', name: '奇幻', icon: 'ri-magic-line' },
  { slug: 'action', name: '动作', icon: 'ri-sword-line' },
  { slug: 'thriller', name: '悬疑', icon: 'ri-search-eye-line' },
  { slug: 'comedy', name: '搞笑', icon: 'ri-emotion-laugh-line' },
  { slug: 'drama', name: '剧情', icon: 'ri-film-line' },
  { slug: 'bl', name: '耽美', icon: 'ri-heart-2-line' },
];

export const comics: Comic[] = [
  {
    id: 'goddess-descends',
    title: '女神降临',
    author: 'Yaongyi',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20romance%20comic%20cover%20featuring%20a%20beautiful%20young%20woman%20with%20long%20dark%20hair%20and%20flawless%20makeup%20transformation%20theme%2C%20soft%20pink%20and%20peach%20color%20palette%2C%20elegant%20illustration%20style%2C%20clean%20composition%20with%20delicate%20details%2C%20light%20pastel%20background%20with%20subtle%20sparkles&width=400&height=600&seq=comic-cover-01&orientation=portrait',
    category: 'romance',
    tags: ['恋爱', '校园', '变身', '治愈'],
    description: '相貌平凡的任朱静通过化妆技术华丽变身为校园女神，在素颜与化妆之间游走，展开了一段充满欢笑与泪水的青春恋爱故事。她遇到了两位截然不同的男生——高冷学霸李修豪和阳光暖男韩书俊，三人之间的情感纠葛扣人心弦。本作以其细腻的画风和对当代年轻人外貌焦虑的深入探讨，赢得了全球读者的喜爱。',
    rating: 9.6,
    status: 'completed',
    chapters: [
      { id: 'ch-1', title: '第1话 平凡的我', number: 1, updatedAt: '2024-01-15' },
      { id: 'ch-2', title: '第2话 化妆的力量', number: 2, updatedAt: '2024-01-16' },
      { id: 'ch-3', title: '第3话 新的开始', number: 3, updatedAt: '2024-01-17' },
      { id: 'ch-4', title: '第4话 相遇', number: 4, updatedAt: '2024-01-18' },
      { id: 'ch-5', title: '第5话 修豪的目光', number: 5, updatedAt: '2024-01-19' },
    ],
    views: 1580000,
    updatedAt: '2026-07-28',
    createdAt: '2024-01-15',
  },
  {
    id: 'solo-leveling',
    title: '我独自升级',
    author: 'Chugong / 张成乐',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20action%20fantasy%20comic%20cover%20with%20a%20powerful%20black-haired%20male%20warrior%20in%20dark%20armor%20surrounded%20by%20purple%20and%20blue%20magical%20energy%20auras%2C%20dramatic%20lighting%20with%20shadows%2C%20epic%20fantasy%20illustration%20style%2C%20dark%20atmospheric%20background%20with%20glowing%20effects&width=400&height=600&seq=comic-cover-02&orientation=portrait',
    category: 'action',
    tags: ['动作', '奇幻', '升级', '热血'],
    description: '十年前，世界突然出现了连接异次元的"门"，部分人类觉醒了特殊能力成为"猎人"。被称为"人类最弱兵器"的E级猎人成振宇，在一次濒死的地下城探险中获得了神秘的"系统"，从此开启了独自升级的逆袭之路。他将如何从最底层一步步踏上成为最强猎人的征途？',
    rating: 9.8,
    status: 'completed',
    chapters: [
      { id: 'ch-1', title: '第1话 觉醒', number: 1, updatedAt: '2024-02-01' },
      { id: 'ch-2', title: '第2话 系统', number: 2, updatedAt: '2024-02-02' },
      { id: 'ch-3', title: '第3话 每日任务', number: 3, updatedAt: '2024-02-03' },
      { id: 'ch-4', title: '第4话 第一次升级', number: 4, updatedAt: '2024-02-04' },
      { id: 'ch-5', title: '第5话 地下城', number: 5, updatedAt: '2024-02-05' },
    ],
    views: 2350000,
    updatedAt: '2026-08-01',
    createdAt: '2024-02-01',
  },
  {
    id: 'omniscient-reader',
    title: '全知读者视角',
    author: 'sing N song / Sleepy-C',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20fantasy%20apocalyptic%20comic%20cover%20featuring%20a%20young%20man%20in%20a%20white%20coat%20reading%20a%20glowing%20book%20surrounded%20by%20floating%20constellation%20symbols%20and%20starry%20sky%2C%20mystical%20blue%20and%20silver%20color%20scheme%2C%20ethereal%20atmosphere%2C%20intricate%20celestial%20design&width=400&height=600&seq=comic-cover-03&orientation=portrait',
    category: 'fantasy',
    tags: ['奇幻', '末世', '穿越', '冒险'],
    description: '普通的上班族金独子是连载了十年的网络小说《在灭亡的世界中生存的三种方法》的唯一读者。当小说完结的那一天，小说中的世界竟然成为了现实。凭借对剧情的全知全能，金独子决定改变这个注定毁灭的世界。但他不知道的是，他的每一个选择都在改写原本的故事走向……',
    rating: 9.7,
    status: 'serializing',
    chapters: [
      { id: 'ch-1', title: '第1话 唯一的读者', number: 1, updatedAt: '2025-03-01' },
      { id: 'ch-2', title: '第2话 世界变了', number: 2, updatedAt: '2025-03-02' },
      { id: 'ch-3', title: '第3话 回归者', number: 3, updatedAt: '2025-03-03' },
      { id: 'ch-4', title: '第4话 第一个剧本', number: 4, updatedAt: '2025-03-04' },
      { id: 'ch-5', title: '第5话 同伴', number: 5, updatedAt: '2025-03-05' },
    ],
    views: 1890000,
    updatedAt: '2026-08-03',
    createdAt: '2025-03-01',
  },
  {
    id: 'sweet-home',
    title: '甜蜜家园',
    author: '金坎比 / 黄英灿',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20horror%20thriller%20comic%20cover%20showing%20a%20dark%20apartment%20building%20with%20a%20lonely%20teenage%20boy%20silhouette%20in%20front%2C%20eerie%20green%20and%20dark%20atmosphere%2C%20monsters%20lurking%20in%20shadows%2C%20creepy%20but%20artistic%20illustration%2C%20cinematic%20composition%20with%20dramatic%20lighting&width=400&height=600&seq=comic-cover-04&orientation=portrait',
    category: 'thriller',
    tags: ['悬疑', '恐怖', '生存', '怪物'],
    description: '因校园霸凌而封闭自我的高中生车贤秀，在失去家人后搬到了一栋破旧的公寓楼。正当他准备结束自己生命的那天，世界突然爆发了恐怖的怪物化现象——人类会因内心的欲望变成可怕的怪物。被困在公寓里的幸存者们，必须团结起来对抗怪物，同时与内心的欲望抗争。',
    rating: 9.5,
    status: 'completed',
    chapters: [
      { id: 'ch-1', title: '第1话 1410号', number: 1, updatedAt: '2024-05-10' },
      { id: 'ch-2', title: '第2话 怪物', number: 2, updatedAt: '2024-05-11' },
      { id: 'ch-3', title: '第3话 封锁', number: 3, updatedAt: '2024-05-12' },
      { id: 'ch-4', title: '第4话 邻居们', number: 4, updatedAt: '2024-05-13' },
      { id: 'ch-5', title: '第5话 欲望', number: 5, updatedAt: '2024-05-14' },
    ],
    views: 1320000,
    updatedAt: '2026-07-20',
    createdAt: '2024-05-10',
  },
  {
    id: 'lookism',
    title: '外貌至上主义',
    author: '朴泰俊',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20drama%20comic%20cover%20showing%20two%20contrasting%20male%20figures%20one%20handsome%20and%20one%20plain%20facing%20each%20other%20like%20mirror%20reflections%2C%20urban%20school%20setting%2C%20bold%20red%20and%20black%20color%20contrast%2C%20stylish%20modern%20illustration%2C%20dramatic%20composition&width=400&height=600&seq=comic-cover-05&orientation=portrait',
    category: 'drama',
    tags: ['剧情', '校园', '双面人生', '热血'],
    description: '胖男孩朴亨锡因为外貌在学校遭受霸凌，忍无可忍的他转学到了首尔。神奇的事情发生了——他拥有了两具身体：一具是原来的肥胖身体，另一具是完美的帅气身体。两具身体交替出现，他需要在两个身份之间找到平衡，同时揭开这一切背后的秘密。',
    rating: 9.4,
    status: 'serializing',
    chapters: [
      { id: 'ch-1', title: '第1话 两个我', number: 1, updatedAt: '2025-01-10' },
      { id: 'ch-2', title: '第2话 新学校', number: 2, updatedAt: '2025-01-11' },
      { id: 'ch-3', title: '第3话 另一个身体', number: 3, updatedAt: '2025-01-12' },
      { id: 'ch-4', title: '第4话 双重生活', number: 4, updatedAt: '2025-01-13' },
      { id: 'ch-5', title: '第5话 秘密', number: 5, updatedAt: '2025-01-14' },
    ],
    views: 1250000,
    updatedAt: '2026-08-02',
    createdAt: '2025-01-10',
  },
  {
    id: 'who-made-me-princess',
    title: '某天成为公主',
    author: 'Plutus / Spoon',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20fantasy%20romance%20comic%20cover%20with%20a%20beautiful%20young%20princess%20in%20an%20elegant%20pink%20and%20gold%20ballgown%20in%20a%20royal%20palace%20setting%2C%20soft%20romantic%20atmosphere%20with%20floating%20rose%20petals%2C%20shojo%20manga%20style%20with%20sparkling%20effects%2C%20warm%20golden%20lighting&width=400&height=600&seq=comic-cover-06&orientation=portrait',
    category: 'romance',
    tags: ['恋爱', '奇幻', '穿越', '宫廷'],
    description: '某天醒来，她发现自己穿越成了小说中注定悲惨死去的公主阿塔娜西娅。面对冷酷无情的父皇克劳德，她决定用可爱和撒娇来改变自己的命运。然而，随着与父皇关系的逐渐改善，她发现这个世界的故事远比自己读过的更加复杂……一段温馨又催泪的父女情和浪漫爱情故事就此展开。',
    rating: 9.6,
    status: 'completed',
    chapters: [
      { id: 'ch-1', title: '第1话 成为公主', number: 1, updatedAt: '2024-07-01' },
      { id: 'ch-2', title: '第2话 父皇', number: 2, updatedAt: '2024-07-02' },
      { id: 'ch-3', title: '第3话 撒娇攻势', number: 3, updatedAt: '2024-07-03' },
      { id: 'ch-4', title: '第4话 命运的转折', number: 4, updatedAt: '2024-07-04' },
      { id: 'ch-5', title: '第5话 皇室的秘密', number: 5, updatedAt: '2024-07-05' },
    ],
    views: 1450000,
    updatedAt: '2026-07-25',
    createdAt: '2024-07-01',
  },
  {
    id: 'mercenary-enrollment',
    title: '入学的佣兵',
    author: 'YC',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20action%20comic%20cover%20featuring%20a%20young%20male%20student%20in%20school%20uniform%20but%20with%20combat%20stance%20and%20intense%20eyes%2C%20military%20and%20mercenary%20elements%20blended%20with%20school%20setting%2C%20dark%20green%20and%20khaki%20color%20scheme%2C%20dynamic%20action%20pose%2C%20sharp%20illustration%20style&width=400&height=600&seq=comic-cover-07&orientation=portrait',
    category: 'action',
    tags: ['动作', '校园', '佣兵', '战斗'],
    description: '曾是世界上最年轻佣兵的王牌战士余镇，完成了所有任务后回到了平凡的校园生活。本想低调度过高中时光的他在开学第一天就遇到了麻烦。当过去的敌人和危险追随时，他不得不在守护平凡日常的同时，展露隐藏在制服之下的真正实力。',
    rating: 9.3,
    status: 'serializing',
    chapters: [
      { id: 'ch-1', title: '第1话 归来', number: 1, updatedAt: '2025-06-01' },
      { id: 'ch-2', title: '第2话 第一天', number: 2, updatedAt: '2025-06-02' },
      { id: 'ch-3', title: '第3话 麻烦来了', number: 3, updatedAt: '2025-06-03' },
      { id: 'ch-4', title: '第4话 隐藏的实力', number: 4, updatedAt: '2025-06-04' },
      { id: 'ch-5', title: '第5话 过去的阴影', number: 5, updatedAt: '2025-06-05' },
    ],
    views: 980000,
    updatedAt: '2026-08-03',
    createdAt: '2025-06-01',
  },
  {
    id: 'study-group',
    title: '流氓读书会',
    author: '申炯旭 / 柳胜延',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20comedy%20action%20comic%20cover%20showing%20a%20tough-looking%20high%20school%20student%20holding%20textbooks%20surrounded%20by%20fighting%20motion%20lines%2C%20humorous%20contrast%20between%20studying%20and%20fighting%2C%20bright%20orange%20and%20yellow%20color%20scheme%2C%20energetic%20and%20dynamic%20illustration%2C%20comic%20exaggeration%20style&width=400&height=600&seq=comic-cover-08&orientation=portrait',
    category: 'comedy',
    tags: ['搞笑', '动作', '校园', '热血'],
    description: '尹佳敏是一名努力学习却成绩始终不理想的高中生。他来到了传说中打架最凶、成绩最差的"流氓高中"，组建了一个读书会。这群看似不良少年的同学们，白天打架、晚上学习，在各种啼笑皆非的事件中，朝着各自的目标前进。一部热血与搞笑交织的校园喜剧！',
    rating: 9.4,
    status: 'serializing',
    chapters: [
      { id: 'ch-1', title: '第1话 传说中的学校', number: 1, updatedAt: '2025-04-01' },
      { id: 'ch-2', title: '第2话 读书会成立', number: 2, updatedAt: '2025-04-02' },
      { id: 'ch-3', title: '第3话 第一次集会', number: 3, updatedAt: '2025-04-03' },
      { id: 'ch-4', title: '第4话 学习与战斗', number: 4, updatedAt: '2025-04-04' },
      { id: 'ch-5', title: '第5话 对手出现', number: 5, updatedAt: '2025-04-05' },
    ],
    views: 870000,
    updatedAt: '2026-08-01',
    createdAt: '2025-04-01',
  },
  {
    id: 'her-private-life',
    title: '她的私生活',
    author: '金成妍',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20romance%20comic%20cover%20featuring%20a%20professional%20woman%20in%20office%20attire%20with%20hidden%20fangirl%20personality%20revealed%20through%20subtle%20idol%20merchandise%20elements%2C%20soft%20mint%20green%20and%20white%20color%20palette%2C%20chic%20and%20modern%20illustration%20style%2C%20clean%20composition%20with%20romantic%20undertones&width=400&height=600&seq=comic-cover-09&orientation=portrait',
    category: 'romance',
    tags: ['恋爱', '职场', '追星', '甜宠'],
    description: '美术馆首席策展人成德美，在职场上是干练专业的精英女性。然而脱下西装后，她是一名狂热的偶像站姐。她小心翼翼地隐藏着这个秘密，直到新任馆长莱恩·金——一位曾经的天才画家——走进了她的生活。当秘密被揭开，两个看似格格不入的人之间产生了意想不到的化学反应。',
    rating: 9.2,
    status: 'completed',
    chapters: [
      { id: 'ch-1', title: '第1话 双面人生', number: 1, updatedAt: '2024-09-01' },
      { id: 'ch-2', title: '第2话 新馆长', number: 2, updatedAt: '2024-09-02' },
      { id: 'ch-3', title: '第3话 秘密被发现', number: 3, updatedAt: '2024-09-03' },
      { id: 'ch-4', title: '第4话 意外的理解', number: 4, updatedAt: '2024-09-04' },
      { id: 'ch-5', title: '第5话 靠近的心', number: 5, updatedAt: '2024-09-05' },
    ],
    views: 760000,
    updatedAt: '2026-07-15',
    createdAt: '2024-09-01',
  },
  {
    id: 'villainess-definition',
    title: '恶女的定义',
    author: '金霞蓝',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20fantasy%20romance%20comic%20cover%20with%20an%20elegant%20villainess%20in%20a%20luxurious%20dark%20red%20and%20black%20gown%2C%20royal%20palace%20background%20with%20dramatic%20shadows%2C%20strong%20female%20character%20with%20confident%20expression%2C%20gothic%20romance%20aesthetic%2C%20rich%20jewel%20tones%2C%20sophisticated%20illustration&width=400&height=600&seq=comic-cover-10&orientation=portrait',
    category: 'fantasy',
    tags: ['奇幻', '恋爱', '恶女', '重生'],
    description: '被未婚夫抛弃、被众人嘲笑的公爵千金赛琳娜，决定按照这个世界的规则扮演一个完美的"恶女"。然而当她不再讨好任何人，开始展现真实自我的时候，那些曾经轻视她的人反而被她的魅力所吸引。连帝国最可怕的大公都对她说："做我的女人吧。"这是一部恶女逆袭的爽快浪漫故事。',
    rating: 9.3,
    status: 'serializing',
    chapters: [
      { id: 'ch-1', title: '第1话 被抛弃的公爵千金', number: 1, updatedAt: '2025-08-01' },
      { id: 'ch-2', title: '第2话 恶女觉醒', number: 2, updatedAt: '2025-08-02' },
      { id: 'ch-3', title: '第3话 新的态度', number: 3, updatedAt: '2025-08-03' },
      { id: 'ch-4', title: '第4话 大公的注意', number: 4, updatedAt: '2025-08-04' },
      { id: 'ch-5', title: '第5话 舞会风波', number: 5, updatedAt: '2025-08-05' },
    ],
    views: 920000,
    updatedAt: '2026-08-02',
    createdAt: '2025-08-01',
  },
  {
    id: 'tower-of-god',
    title: '神之塔',
    author: 'SIU',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20fantasy%20adventure%20comic%20cover%20showing%20a%20mysterious%20boy%20climbing%20a%20massive%20tower%20with%20floating%20floors%20and%20magical%20symbols%2C%20epic%20scale%20with%20intricate%20architectural%20design%2C%20turquoise%20and%20gold%20color%20palette%2C%20grand%20adventure%20atmosphere%2C%20highly%20detailed%20fantasy%20art&width=400&height=600&seq=comic-cover-11&orientation=portrait',
    category: 'fantasy',
    tags: ['奇幻', '冒险', '战斗', '史诗'],
    description: '只要登顶神之塔，就能实现任何愿望。少年二十五夜为了追寻唯一的朋友蕾哈尔，打开了神之塔的大门。在这个充满试炼与背叛的高塔世界中，他结识了各种奇特的伙伴，也面对着残酷的考验。神之塔的每一层都是一个世界，而他的冒险才刚刚开始。',
    rating: 9.7,
    status: 'serializing',
    chapters: [
      { id: 'ch-1', title: '第1话 塔之门', number: 1, updatedAt: '2024-03-01' },
      { id: 'ch-2', title: '第2话 第一层', number: 2, updatedAt: '2024-03-02' },
      { id: 'ch-3', title: '第3话 试炼开始', number: 3, updatedAt: '2024-03-03' },
      { id: 'ch-4', title: '第4话 同伴', number: 4, updatedAt: '2024-03-04' },
      { id: 'ch-5', title: '第5话 守护者', number: 5, updatedAt: '2024-03-05' },
    ],
    views: 2100000,
    updatedAt: '2026-08-03',
    createdAt: '2024-03-01',
  },
  {
    id: 'noblesse',
    title: '大贵族',
    author: '孙齐皓 / 李光洙',
    cover: 'https://readdy.ai/api/search-image?width=400&height=600&seq=comic-cover-12&orientation=portrait&query=Korean%20manhwa%20supernatural%20action%20comic%20cover%20featuring%20an%20elegant%20noble%20vampire%20with%20silver%20hair%20and%20red%20eyes%20in%20a%20black%20suit%2C%20gothic%20modern%20fusion%20style%2C%20dark%20elegant%20atmosphere%20with%20crimson%20accents%2C%20aristocratic%20and%00powerful%20presence%2C%00sophisticated%20dark%20fantasy%20illustration',
    category: 'action',
    tags: ['动作', '奇幻', '吸血鬼', '校园'],
    description: '沉睡了820年的贵族卡迪斯·艾特拉马·迪·莱杰罗在现代韩国醒来。为了适应新世界，他进入了一所高中。他拥有超越人类的力量，却对现代社会的一切充满好奇。当他忠诚的仆人弗兰克斯坦和过去的敌人陆续出现，一场跨越千年的战争在现代都市中悄然展开。',
    rating: 9.5,
    status: 'completed',
    chapters: [
      { id: 'ch-1', title: '第1话 觉醒', number: 1, updatedAt: '2023-11-01' },
      { id: 'ch-2', title: '第2话 新世界', number: 2, updatedAt: '2023-11-02' },
      { id: 'ch-3', title: '第3话 学校', number: 3, updatedAt: '2023-11-03' },
      { id: 'ch-4', title: '第4话 仆人归来', number: 4, updatedAt: '2023-11-04' },
      { id: 'ch-5', title: '第5话 暗影中的敌人', number: 5, updatedAt: '2023-11-05' },
    ],
    views: 1780000,
    updatedAt: '2026-07-30',
    createdAt: '2023-11-01',
  },
];

export const getComicsByCategory = (categorySlug: string): Comic[] => {
  if (categorySlug === 'all') return comics;
  return comics.filter((c) => c.category === categorySlug);
};

export const getComicById = (id: string): Comic | undefined => {
  return comics.find((c) => c.id === id);
};

export const getRelatedComics = (comic: Comic, count: number = 4): Comic[] => {
  return comics
    .filter((c) => c.id !== comic.id && c.category === comic.category)
    .slice(0, count);
};

export const getHotComics = (count: number = 6): Comic[] => {
  return [...comics].sort((a, b) => b.rating - a.rating).slice(0, count);
};

export const getLatestComics = (count: number = 6): Comic[] => {
  return [...comics].sort((a, b) => new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime()).slice(0, count);
};

export const getPopularComics = (count: number = 5): Comic[] => {
  return [...comics].sort((a, b) => b.views - a.views).slice(0, count);
};